<template>
  <el-dialog
    :title="$t('taskCenter.label.closeTask')"
    :visible.sync="taskCloseStatus"
    :before-close="taskCloseCancel"
    width="550px"
    :close-on-click-modal="false"
    class="close-container"
  >
    <div>
      <el-form :model="form" :rules="rules" ref="closeForm" label-width="80px">
        <el-form-item label="关闭原因" prop="taskCloseReason">
          <el-select
            style="width: 100%"
            v-model="form.taskCloseReason"
            placeholder="请选择原因"
            @change="changeValue"
          >
            <el-option
              v-for="item in closeInfo"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原因描述" prop="taskCloseReasonDes">
          <el-input
            type="textarea"
            v-model="form.taskCloseReasonDes"
            :rows="3"
            maxlength="200"
            placeholder="请输入描述"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="taskCloseCancel" type="info">{{
        $t("taskCenter.button.cancel")
      }}</el-button>
      <el-button type="primary" @click="taskCloseSubmit">{{
        $t("taskCenter.button.save")
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { API } from "../api";
export default {
  // 关闭原因
  props: ["taskCode"],
  data() {
    return {
      rules: {
        taskCloseReason: [
          {
            required: true,
            message: "请选择原因",
            trigger: ["blur", "change"],
          },
        ],
        taskCloseReasonDes: [
          { required: true, message: "请输入描述", trigger: ["blur"] },
        ],
      },
      form: {
        taskCloseReason: "",
        taskCloseReasonDes: "",
      },
      taskCloseStatus: false,
      // 关闭选项
      closeInfo: [
        {
          value: "1",
          label: this.$t("taskCenter.message.dealSuc"),
        },
        {
          value: "2",
          label: this.$t("taskCenter.message.taskEAnd"),
        },
      ],
    };
  },
  methods: {
    // 根据select的值 改变input框的值
    changeValue() {
      this.form.taskCloseReasonDes = this.form.taskCloseReason;
    },
    // 关闭 取消按钮触发
    taskCloseCancel() {
      this.$refs.closeForm.resetFields();
      this.taskCloseStatus = false;
    },
    //关闭 保存按钮触发
    taskCloseSubmit() {
      this.$refs.closeForm.validate((res) => {
        if (!res) {
          return;
        }
        let params = {
          taskCode: this.taskCode,
          closeCause: this.form.taskCloseReasonDes,
        };
        this.$fetch(API.bas.closeTaskInfo, params).then((res) => {
          if (res.success) {
            this.$message({
              message: this.$t("taskCenter.button.close"),
              type: "success",
            });
            this.taskCloseCancel();
            this.$emit("closeTaskSuccess");
          } else {
            this.$message({
              message: res.msgContent,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>